import { render, staticRenderFns } from "./PortionsTable.vue?vue&type=template&id=43b2f656&scoped=true&"
import script from "./PortionsTable.vue?vue&type=script&lang=js&"
export * from "./PortionsTable.vue?vue&type=script&lang=js&"
import style0 from "./PortionsTable.vue?vue&type=style&index=0&id=43b2f656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b2f656",
  null
  
)

export default component.exports